/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { Configuration } from '../../../Configuration';
import { RestServiceProvider } from '../../RestServiceProvider';
import {ExportsService, StatisticsService} from './ExportsService';

class ExportsServiceProvider extends RestServiceProvider {
    getServiceInstance($q, resource, $httpParamSerialiserJQLike, $log) {
        return new ExportsService($q, resource, $httpParamSerialiserJQLike, $log);
    }

    generateExportsConfig(url) {
        return {
            url: url + Configuration.EXPORTS_CREATE_PATH,
            method: 'POST',
            transformResponse:
                (data, headers, status) => {
                 if ((status === 401) || (status === 403)) {
                     return null;
                 } else {
                     let file = {};
                     file.id = data;
                     return file;
                 }
            }
        };
    }

    getExportsStatusConfig(url) {
        return {
            url: url + Configuration.EXPORTS_STATUS_PATH,
            method: 'GET',
            transformResponse:
                (data, headers, status) => {
                    if ((status === 401) || (status === 403)) {
                        return null;
                    } else {
                        let exportStatus = {};
                        exportStatus.status = data;
                        return exportStatus;
                    }
                }
        };
    }

    /** @ngInject */
    getConfig() {
        const config = super.getConfig();
        config.generateExports = this.generateExportsConfig(this.resourceUrl);
        config.getExportsStatus = this.getExportsStatusConfig(this.resourceUrl);
        return config;
    }
}

export { ExportsServiceProvider };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/exports/service/ExportsServiceProvider.js